/* tslint:disable */
import {
  Admin,
  Language
} from '../index';

declare var Object: any;
export interface TranslationInterface {
  "name": string;
  "id"?: any;
  "translationableId"?: any;
  "translationableType"?: string;
  "adminId"?: any;
  "languageId"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  translationable?: any;
  admin?: Admin;
  language?: Language;
}

export class Translation implements TranslationInterface {
  "name": string;
  "id": any;
  "translationableId": any;
  "translationableType": string;
  "adminId": any;
  "languageId": any;
  "createdAt": Date;
  "updatedAt": Date;
  translationable: any;
  admin: Admin;
  language: Language;
  constructor(data?: TranslationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Translation`.
   */
  public static getModelName() {
    return "Translation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Translation for dynamic purposes.
  **/
  public static factory(data: TranslationInterface): Translation{
    return new Translation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Translation',
      plural: 'translations',
      path: 'translations',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "translationableId": {
          name: 'translationableId',
          type: 'any'
        },
        "translationableType": {
          name: 'translationableType',
          type: 'string'
        },
        "adminId": {
          name: 'adminId',
          type: 'any'
        },
        "languageId": {
          name: 'languageId',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        translationable: {
          name: 'translationable',
          type: 'any',
          model: '',
          relationType: 'belongsTo',
                  keyFrom: 'translationableId',
          keyTo: 'id'
        },
        admin: {
          name: 'admin',
          type: 'Admin',
          model: 'Admin',
          relationType: 'belongsTo',
                  keyFrom: 'adminId',
          keyTo: 'id'
        },
        language: {
          name: 'language',
          type: 'Language',
          model: 'Language',
          relationType: 'belongsTo',
                  keyFrom: 'languageId',
          keyTo: 'id'
        },
      }
    }
  }
}
